// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1XlZC","actions":"GroupTable_actions__35rrn","deleteModalFooter":"GroupTable_deleteModalFooter__3-xFV"};